import React from 'react'
import {FileCheck, RefreshCw, DollarSign} from 'lucide-react'

const features = [
  {
    icon: FileCheck,
    title: 'Outstanding Invoice Management',
    description: 'Track unpaid invoices and past due invoices with ease. Never miss a payment again with our intuitive outstanding invoice tracking system.'
  },
  {
    icon: RefreshCw,
    title: 'Recurring Billing',
    description: 'Set up automatic recurring invoices for regular clients. Save time with automated invoice generation for monthly or weekly services.'
  },
  {
    icon: DollarSign,
    title: 'Multi-currency Support',
    description: 'Create invoices in any currency. Perfect for international freelancers and contractors working with clients worldwide.'
  }
]

const FeatureGrid = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {features.map((feature, index) => (
        <div 
          key={index}
          className="bg-white p-6 rounded-lg shadow-md border border-gray-200 hover:shadow-xl transition-shadow"
        >
          <div className="w-12 h-12 bg-[#047857] bg-opacity-10 rounded-lg flex items-center justify-center mb-4">
            <feature.icon className="w-6 h-6 text-[#047857]" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-3">
            {feature.title}
          </h3>
          <p className="text-gray-600">
            {feature.description}
          </p>
        </div>
      ))}
    </div>
  )
}

export default FeatureGrid
